import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';

export const StyledRegistryCross = styled(Box)`
  position: relative;
  background-color: #fef3ea;
`;

export const StyledCenterBody = styled(Box)`
  width: 100%;
`;

export const BottomWave = styled(CloudImage)`
  width: 100%;
  height: 150px;
  object-fit: cover;
  position: absolute;
  bottom: -85px;
  object-position: top;
`;

export const ButtonsContainer = styled(Flex)`
  max-width: 620px;
  justify-content: center;
  align-items: center;
  > a {
    background: none;
  }
  > *:not(:first-child) {
    margin-left: ${themeSpace(10)};
  }
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    > *:not(:first-child) {
      margin-left: ${themeSpace(0)};
      margin-top: ${themeSpace(8)};
    }
  }
`;

export const FeatureText = styled(Text)`
  margin-top: ${themeSpace(4)};
  max-width: 190px;
  ${themeMediaQuery('below_sm')} {
    margin-bottom: ${themeSpace(8)};
  }
`;

export const CrossTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 500px;
  }
  .text-pairing-title {
    max-width: 260px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 55%;
    }
    .text-pairing-title {
      max-width: 100%;
    }
  }
`;

export const StyledTextColumn = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;
